<div id="create-user" class="modify-user">
  <div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-primary">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
        <span class="title dialog-title">
          {{ 'USER.AVS-CONFIRM.VALID-CHANGE' | translate }}
        </span>
        <button
          mat-icon-button
          (click)="matDialogRef.close(isUserUpdated)"
          aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="user-form">
      {{ 'USER.AVS-CONFIRM.USER-NEWINFO' | translate }}
      <ul class="modification-list">
        @for (controlName of updatedUserFormControls; track controlName) {
          <li>
            <span
              [innerHTML]="getLabelForControl(controlName) | translate"></span>
            <b> {{ getUpdatedUserFormValue(controlName) }}</b>
          </li>
        }
      </ul>
      <div class="form-control">
        <div class="general-container" fxLayout="row" fxLayoutAlign="left left">
          <button
            mat-raised-button
            type="button"
            color="accent"
            [disabled]="isUserUpdated"
            (click)="updateUserInfo()">
            {{ 'USER.AVS-CONFIRM.CONFIRM-MODIFICATION' | translate }}
          </button>
        </div>
        @if (isBusy) {
          <div
            class="general-container"
            fxLayout="column"
            fxLayoutAlign="center center">
            <mat-progress-spinner
              [color]="spinner.color"
              [mode]="spinner.mode"
              [value]="spinner.value"
              [diameter]="spinner.diameter">
            </mat-progress-spinner>
          </div>
        }
        @if (isErrorUpdateUser) {
          <div class="general-container">
            <div class="message-box error">
              <app-error-message [error]="errorUpdateUser.error" />
            </div>
          </div>
        }
        @if (isUserUpdated) {
          <div class="general-container">
            <div class="message-box success">
              {{ 'USERUPDATE.SUCCESS-UPDATE' | translate }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
